<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'file-invoice']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('global.accounting_code') }}
        </span>
      </div>
    </template>

    <template #body>
      <div class="flex flex-col gap-4">
        <PageSection disable-sticky-margin :title="$t('button.add')">
          <div
            class="grid grid-cols-1 items-end gap-x-5 gap-y-3 md:grid-cols-3"
          >
            <BaseInput
              :label="$t('global.code')"
              :placeholder="$t('global.code')"
              name="code"
              :required="true"
              v-model="accountingCode.code"
            />

            <BaseInput
              :label="$t('global.entitled')"
              :placeholder="$t('global.entitled')"
              name="name"
              v-model="accountingCode.name"
              :required="true"
            />

            <BaseButton
              color="primary"
              icon="plus"
              @click="submitAccountingCode"
              :title="$t('button.add')"
            />
          </div>
        </PageSection>
        <PageSection
          disable-sticky-margin
          :title="$t('global.accounting_code')"
        >
          <div class="overflow-x-auto">
            <table class="table--sm table">
              <thead class="bg-gray-50">
                <tr
                  class="px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500 uppercase"
                >
                  <th scope="col">{{ $t('global.code') }}</th>
                  <th scope="col">{{ $t('global.entitled') }}</th>
                </tr>
              </thead>
              <tbody class="bg-gray-50">
                <tr
                  v-for="(accountingCode, idx) in accountingCodesList"
                  :key="idx"
                  :class="idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                  class="cursor-pointer px-6 py-4 text-sm font-medium whitespace-nowrap text-gray-600"
                >
                  <td>{{ accountingCode.code }}</td>
                  <td>{{ accountingCode.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </PageSection>
      </div>
    </template>
  </SettingsPageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheAccountingCodePage',
  computed: {
    ...mapGetters({
      accountingCodesList: 'accountingCode/getAccountingCodeList',
      accountingCode: 'accountingCode/getAccountingCode'
    })
  },
  methods: {
    ...mapActions({
      fetchAccountingCodes: 'accountingCode/fetchAccountingCodeList',
      storeAccountingCode: 'accountingCode/storeAccountingCode'
    }),
    getInputValue({ attribute, value }) {
      this.accountingCode[attribute] = value
    },
    submitAccountingCode() {
      this.storeAccountingCode({ accountingCode: this.accountingCode })
      this.accountingCode.name = ''
      this.accountingCode.code = ''
    }
  },
  mounted() {
    this.fetchAccountingCodes()
  }
}
</script>
